import React from "react";
import spotGroupIcon from "../../assets/icons/spot-group-white.svg";
import useSpotGroupService from "../../api/services/useSpotGroupService";
import Button from "../../components/Button/Button";
import TileList from "../../components/TileList/TileList";
import FeedbackPopup from "../../components/FeedbackPopup/FeedbackPopup";


const UserSpotGroups = () => {

  const {userShowCollection} = useSpotGroupService()

  return (
    <div className="page-user-spot_groups">
      <div className="row">
        <div className="col">
          <h1>Locaties</h1>
        </div>
        <div className="col col-feedback">
          <FeedbackPopup
            location="/user/locaties"
          />
        </div>
      </div>
      <p>Locaties zijn: markten, evenementen, kantoor tereinen, winkelcentra's, braderien, festivals. Een locatie heeft
        een of meerdere standplaatsen die een stand/mobiele ondernemer kan boeken en gebruiken om zijn
        goederen te verkopen!</p>
      <Button
        label="Locatie aanmaken"
        linkState={{buttonPrev:{new:{onClick:{navigate:'/user/locaties'}}}}}
        link="/wizard/locatie/new"
        icon={spotGroupIcon}
      />
      <br/>
      <br/>
      <br/>
      <TileList
        apiServiceShow={userShowCollection}
        modelLabelKey="label"
        modelImageKey="overview_media"
        showBookableStatus={true}
        buttonProfileBaseUrl={'/locatie/'}
        buttonOneDynamicUrl={'/user/locatie/%id/manager'}
        buttonOneLabel={'Boekingen'}
        buttonThreeDynamicUrl={'/user/locatie/%id/edit'}
        buttonThreeLabel={'Instellingen'}
        buttonTwoDynamicUrl={'/user/profile-boosts'}
        buttonTwoLabel={'Omhoog plaatsen'}
      />
    </div>
  )
}

export default UserSpotGroups
